import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckcoverageComponent } from './checkcoverage.component';

const routes: Routes = [
    {
        path: '',
        component: CheckcoverageComponent,
        data: {
            title: 'CheckCoverage'
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CheckcoverageRoutingModule { }
